import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Setting } from '../../entities/setting/setting';
import { ApolloService } from '../apollo.service';
import * as fromGraphQl from './graphql';

@Injectable()
export class SettingsService {
  constructor(
    private apolloService: ApolloService,
  ) {}

  public updateSettings(settingInput: any, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.UPDATE_SETTINGS,
      {
        settingInput,
      },
      callback
    );
  }

  public resetSetting(key: string, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.RESET_SETTING,
      {
        key,
      },
      callback
    );
  }

  public resetSettingLocation(key: string, locationId: any, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.RESET_SETTING_LOCATION,
      {
        key,
        locationId
      },
      callback
    );
  }

  public updateUserSettings(userSettings: any, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.UPDATE_USER_SETTINGS,
      {
        userSettings,
      },
      callback
    );
  }

  public getSetting(settingName: string, callback: (setting: Setting) => any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.GET_SETTING_QUERY,
      {
        settingName
      },
      (result) => {
        callback(new Setting(result?.data?.getSetting));
      }
    );
  }

  public createSettingsFormGroup(settings: any): FormGroup {
    let settingsForm = new FormGroup({});
    for (let setting of settings) {
      setting?.settingDescriptions.forEach((control: any) => {
        if(control.type === 'Boolean') {
          let correctedValue = undefined;
          if(control.currentValue !== undefined){
            if(control.currentValue === 'true'){
              correctedValue = true;
            } else if(control.currentValue === 'false'){
              correctedValue = false;
            } else {
              correctedValue = control.currentValue;
            }
          }
          settingsForm.addControl(control.key, new FormControl(correctedValue));
        } else {
          settingsForm.addControl(control.key, new FormControl(control.currentValue));
        }
      });
    }
    return settingsForm;
  }
}
